import type { TFunction } from 'i18next';

/**
 * What a recipe's stored `diets` read as on a chip. The field holds tags
 * ("glutenfree", "lowlactose", "gluten free"), which used to print as they are.
 * A tag not listed here is left off: an unknown word on a chip tells a cook less
 * than no chip.
 */
const DIET_LABELS: Record<string, (t: TFunction) => string> = {
  vegetarian: t => t('diet.vegetarian'),
  vegan: t => t('diet.vegan'),
  glutenfree: t => t('diet.glutenFree'),
  dairyfree: t => t('diet.dairyFree'),
  lowlactose: t => t('diet.lowLactose'),
  fish: t => t('recipeMetadata.diets.fish'),
  healthy: t => t('diet.healthy'),
};

export function dietLabels(diets: readonly string[] | undefined, t: TFunction): string[] {
  return (diets ?? []).flatMap(diet => {
    const label = DIET_LABELS[diet.toLowerCase().replace(/[\s_-]/g, '')];
    return label ? [label(t)] : [];
  });
}
